/**
 * Facets store
 */
import { getPersistedValue } from '@/helpers/store.js';

const maxAge = 345600000; // 96 hours (4 days) [msec]

const initialState = () => ({
    artworksFacetsPublicOnly: {},
    artworksFacetsViewAll: {},
    timestamps: {}
});

const createStore = (Vue) => {

    const state = initialState;

    const getters = {
        getArtworksFacetsPublicOnly (state) {
            return state.artworksFacetsPublicOnly;
        },

        getArtworksFacetsViewAll (state) {
            return state.artworksFacetsViewAll;
        }
    };

    const actions = {
        async fetchArtworksFacetsPublicOnly ({ commit, state }) {
            // check persisted localStorage
            const value = getPersistedValue(state, 'artworksFacetsPublicOnly', maxAge);
            if (value) {
                return Promise.resolve(value);
            }

            const params = {
                AutoWildcards: false,
                EnableFacetedSearch: true,
                // ArtworkFacets: '[Classification,SubClassification,PublishedKeeperSorted,ArtistSorted,ProductionAtmostBeginYear,Colors]',
                ArtworkFacets: '[Classification,SubClassification,ProductionAtmostBeginYear,Colors]',
                PageSize: 1,
                UseProfile: 'PublicOnly',
                Template: {
                    PrimaryProperties: false,
                    IndexProperties: false,
                    ObjectProperties: false,
                    IngressProperties: false,
                    CuratorProperties: false,
                    ArtworkProperties: false,
                    DetailProperties: false
                }
            };

            // fetch
            return new Promise((resolve, reject) => {
                // query fresh artworks facets
                Vue.prototype.$SVC.queryArtworks(params)
                    .then((response) => {
                        const facets = response && response.data && response.data.FacetResults;
                        commit('setArtworksFacetsPublicOnly', facets);
                        resolve(facets);
                    })
                    .catch(reject);
            });
        },

        async fetchArtworksFacetsViewAll ({ commit, state }) {
            // check persisted localStorage
            const value = getPersistedValue(state, 'artworksFacetsViewAll', maxAge);
            if (value) {
                return Promise.resolve(value);
            }

            const params = {
                AutoWildcards: false,
                EnableFacetedSearch: true,
                // ArtworkFacets: '[Classification,SubClassification,PublishedKeeperSorted,ArtistSorted,ProductionAtmostBeginYear,Colors]',
                ArtworkFacets: '[Classification,SubClassification,ProductionAtmostBeginYear,Colors]',
                PageSize: 1,
                UseProfile: 'ViewAll',
                Template: {
                    PrimaryProperties: false,
                    IndexProperties: false,
                    ObjectProperties: false,
                    IngressProperties: false,
                    CuratorProperties: false,
                    ArtworkProperties: false,
                    DetailProperties: false
                }
            };

            // fetch
            return new Promise((resolve, reject) => {
                // query fresh artworks facets
                Vue.prototype.$SVC.queryArtworks(params)
                    .then((response) => {
                        const facets = response && response.data && response.data.FacetResults;
                        commit('setArtworksFacetsViewAll', facets);
                        resolve(facets);
                    })
                    .catch(reject);
            });
        }
    };

    const mutations = {
        RESET (state) {
            const newState = initialState();
            Object.keys(newState).forEach((key) => {
                state[key] = newState[key];
            });
        },

        setArtworksFacetsPublicOnly (state, value) {
            state.artworksFacetsPublicOnly = value || {};
            state.timestamps.artworksFacetsPublicOnly = new Date();
        },

        setArtworksFacetsViewAll (state, value) {
            state.artworksFacetsViewAll = value || {};
            state.timestamps.artworksFacetsViewAll = new Date();
        }
    };

    return {
        namespaced: true,
        state,
        getters,
        actions,
        mutations
    };
};

export default app => createStore(app);
